import type { IVariable, TextVariable } from '@carboncopyco/types';
import { TextBoxEditorTitle } from '@carboncopyco/ui';
import { VariableInputField } from './VariableInputField';

export interface VariablesTableProps {
  variables: IVariable[];
  renderVariableInput: (variable: IVariable, index: number) => React.ReactNode;
  showHeaders?: boolean;
}

export const VariablesTable = ({
  variables,
  renderVariableInput,
  showHeaders = true,
}: VariablesTableProps) => {
  return (
    <div className="w-full flex flex-col justify-center items-center overflow-hidden">
      {showHeaders && (
        <div className="w-full flex">
          <div className="w-ds-42 h-8">
            <TextBoxEditorTitle
              color="text-ds-natural-200"
              label="Variables"
              uppercase
            />
          </div>
          <div className="flex-1 h-8">
            <TextBoxEditorTitle
              color="text-ds-natural-200"
              label="Replace with"
              uppercase
            />
          </div>
        </div>
      )}
      <div className="w-full overflow-x-hidden overflow-y-auto">
        {variables.map((variable, index) => (
          <VariableInputField
            variable={variable}
            key={variable.variableId ?? (variable as TextVariable).code}
          >
            {renderVariableInput(variable, index)}
          </VariableInputField>
        ))}
      </div>
    </div>
  );
};
